<!-- eslint-disable max-len -->
<template>
  <Dialog
    v-model:visible="state$$.supportNumberInfo.isVisible"
    class="info-support-number-nie-dialog"
    :dismissable-mask="false"
    :modal="false"
    style="max-width: 700px"
    :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
  >
    <template #header>
      Información de número de soporte de DNI/NIE
    </template>

    <div class="info-support-number-nie-dialog__body">
      <div class="info-support-number-nie-dialog__body__c">
        <h4>DNI:</h4>
        <p>
          Para encontrar el código de soporte en tu Documento Nacional de
          Identidad, localízalo de la siguiente manera dependiendo de la versión
          de tu DNI: En el DNI 3.0, el código se sitúa debajo del título "Número
          de Soporte", visible en la parte frontal del documento. Para el DNI
          2.0, el código aparece bajo el título "IDESP", también en la parte
          frontal, tal y como se muestran en las siguientes imágenes.
        </p>
        <div class="info-support-number-nie-dialog__body__c__images">
          <Image
            :src="props$$.imageSupportNumberDNI"
            alt="Image"
            width="250"
            preview
          />
        </div>
      </div>
      <div class="info-support-number-nie-dialog__body__c">
        <h4>Ciudadanos de la Unión Europea:</h4>
        <p>
          El número de soporte aparece en el reverso de tu tarjeta de
          Certificado de Registro de Ciudadano de la Unión. Debe introducirse
          precedido de la letra “C” y, en el caso de tener menos de 8 dígitos,
          debe rellenarse por la izquierda con ceros (0) hasta llegar a 8
          dígitos. Ejemplo: 76292 debe introducirse como C00076292.
        </p>
        <div class="info-support-number-nie-dialog__body__c__images">
          <Image
            :src="props$$.imageSupportNumberC"
            alt="Image"
            width="250"
            preview
          />
        </div>
      </div>
      <div class="info-support-number-nie-dialog__body__e">
        <h4>Residentes con Tarjeta de Extranjero:</h4>
        <p>
          El número de soporte aparece en el anverso de la tarjeta de
          extranjero. Consiste en la letra “E” seguida de 8 dígitos. Ejemplo:
          E03920483.
        </p>
        <div class="info-support-number-nie-dialog__body__e__images">
          <Image
            :src="props$$.imageSupportNumberE"
            alt="Image"
            width="250"
            preview
          />
        </div>
      </div>
    </div>

    <template #footer>
    </template>
  </Dialog>
</template>

<script setup>
// #region VUE
import {inject, onBeforeUnmount} from 'vue';
// #endregion

// #region Components
import Dialog from 'primevue/dialog/sfc';
import Image from 'primevue/image/sfc';
// #endregion

// #region Props, Emits
const props$$ = defineProps({
  imageSupportNumberC: {
    type: String,
    default: require('@/assets/images/info-support-number-c.png'),
  },
  imageSupportNumberE: {
    type: String,
    default: require('@/assets/images/info-support-number-e.png'),
  },
  imageSupportNumberDNI: {
    type: String,
    default: require('@/assets/images/info-support-number-dni.png'),
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const state$$ = inject('registerState$$');
// #endregion

// #region Effects, Hooks
onBeforeUnmount(() => {
  const field = document.querySelector('.form__item--supportnumber input');
  if (!field) return;
  field.focus();
});
// #region Effects, Hooks
</script>

<style lang="scss" scoped>
@use "@/styles/vars" as *;
@use "@/styles/breakpoints" as *;
.info-support-number-nie-dialog {
  &__body {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: $brand__boxspace--medium;
    &__e,
    &__c {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: $brand__boxspace--small;
      text-align: left;
      & h4 {
        margin-left: 0;
      }
      &__images {
        display: flex;
        flex-direction: row;
        gap: $brand__boxspace--medium;
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
